// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmotionCharacterButton__surface___b33AN {
    --emotion-hold-charge: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: visible;
    transition: transform 90ms ease, filter 90ms ease;
    transform: translateY(0) scale(1);
    filter: brightness(1) saturate(1);
    user-select: none;
    -webkit-user-select: none;
}

.EmotionCharacterButton__active___OTpw2 {
    width: 51px;
    height: 81.6px;
}

.EmotionCharacterButton__pressed___C2VbG {
    transform: translateY(5px) scale(0.965);
    filter: brightness(1.04) saturate(1.08) contrast(1.01)
        drop-shadow(0 0 7px rgba(255, 206, 105, 0.45))
        drop-shadow(0 0 12px rgba(255, 241, 204, 0.14));
}

.EmotionCharacterButton__active___OTpw2.EmotionCharacterButton__pressed___C2VbG {
    transform: translateY(5px) scale(0.955);
    filter: brightness(1.08) saturate(1.18) contrast(1.02)
        drop-shadow(0 0 8px rgba(255, 210, 120, 0.55))
        drop-shadow(0 0 14px rgba(255, 242, 205, 0.18));
}

.EmotionCharacterButton__holdable___pe79a {
    touch-action: none;
    -webkit-touch-callout: none;
}

.EmotionCharacterButton__chargeGlow___t0Ema {
    position: absolute;
    left: calc(50% - 72px);
    top: calc(50% - 71px);
    width: 144px;
    height: 142px;
    z-index: 0;
    pointer-events: none;
    background: radial-gradient(ellipse at center,
        rgba(255, 240, 182, 0.78) 0%,
        rgba(255, 208, 105, 0.67) 16%,
        rgba(232, 171, 47, 0.42) 34%,
        rgba(181, 118, 20, 0.18) 49%,
        transparent 70%);
    opacity: calc(var(--emotion-hold-charge) * var(--emotion-hold-charge) * 0.95);
    transform: scale(calc(0.72 + var(--emotion-hold-charge) * 0.28));
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"surface": `EmotionCharacterButton__surface___b33AN`,
	"active": `EmotionCharacterButton__active___OTpw2`,
	"pressed": `EmotionCharacterButton__pressed___C2VbG`,
	"holdable": `EmotionCharacterButton__holdable___pe79a`,
	"chargeGlow": `EmotionCharacterButton__chargeGlow___t0Ema`
};
module.exports = ___CSS_LOADER_EXPORT___;
